module.exports = __webpack_public_path__ + "img/h-bg.406c63f2.png";